import { render, staticRenderFns } from "./viewUpgrade.vue?vue&type=template&id=babdf992&scoped=true&"
import script from "./viewUpgrade.vue?vue&type=script&lang=js&"
export * from "./viewUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./viewUpgrade.vue?vue&type=style&index=0&id=babdf992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babdf992",
  null
  
)

component.options.__file = "viewUpgrade.vue"
export default component.exports